var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9285 4.36364H0V3.63636C0 1.63127 1.58879 0 3.54167 0H5.33233C5.66029 0 5.98896 0.0792727 6.28221 0.229818L8.51771 1.37745C8.61546 1.42764 8.72525 1.45382 8.83433 1.45382H13.4583C15.1683 1.45382 16.5991 2.70618 16.9285 4.36364ZM17 5.81818V12.3636C17 14.3687 15.4112 16 13.4583 16H3.54167C1.58879 16 0 14.3687 0 12.3636V5.81818H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a0be3c3c5e646d760ce51545c8d4d400.svg";
export { ForwardRef as ReactComponent };